const initialState = {
  total_pages: 1,
  current_page: 1,
  notes: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "DELETE_NOTE":
      let notes = state.notes.filter((note) => {
        return note.id !== action.payload.note.id;
      });

      return { ...state, notes };
    case "CREATE_NOTE":
      let new_note = action.payload.note;
      return { ...state, notes: { ...state.notes, ...new_note } };
    case "UPDATE_NOTE":
      let newNotes = state.notes.map((item) => {
        if (item.id === action.payload.note.id) {
          return action.payload.note;
        } else {
          return item;
        }
      });
      newNotes.sort((a, b) => b - a);

      return { ...state, notes: newNotes };
    case "UPDATE_NOTES":
      return action.payload.notes;
    case "UPDATE_CURRENT_PAGE":
      return {
        ...state,
        current_page: action.payload.currentPage,
      };
    default:
      return state;
  }
};
